import { Inquery1, Inquery2, Inquery3, Inquery4 } from "../../../assets";
import { Layout } from "../../components";
import { Button } from "../../components/button";
import FaqCard from "../../components/faq_card";
import { InsuranceRateController } from "../../controllers";
import { Helmet } from "react-helmet-async";
import { connect } from "react-redux";

class InsuranceRate extends InsuranceRateController {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const { active } = this.state;

    return (
      <Layout title="استعلام حق‌بیمه و ثبت پیشنهاد ">
        <Helmet>
          <title>استعلام حق‌بیمه و ثبت پیشنهاد  | بیمه زندگی هامرز</title>
        </Helmet>

        <div className="insurance-rate scrollbar">
          <p className="insurance-rate-description">
               خواهشمند است جهت استعلام و خرید بیمه  ، یکی از بیمه نامه های زیر را انتخاب و به مرحله بعد بروید.   
          </p>

          <div className="insurance-rate-cards">
            <FaqCard
              active={active === 1}
              myStyle={active === 1 ? "" : "deactive"}
              title="زندگی و سرمایه گذاری"
              image={Inquery1}
              onClick={() => this.setState({ active: 1 })}
            />
            <FaqCard
              active={active === 2}
              myStyle={active === 2 ? "" : "deactive"}
              title="زندگی متصل به"
              subTitle="صندوق های بازار سرمایه"
              image={Inquery2}
              onClick={() => this.setState({ active: 2 })}
            />
            <FaqCard
              active={active === 3}
              myStyle={active === 3 ? "" : "deactive"}
              title="زندگی و مسکن"
              subTitle="(مسکن متری)"
              image={Inquery3}
              onClick={() => this.setState({ active: 3 })}
            />
            <FaqCard
              myStyle="disable"
              title="مستمری متصل به معدن"
              image={Inquery4}
              onClick={() => {}}
            />
          </div>

          <Button
            myStyle="bg-blue table-btn"
            title="مرحله بعد"
            onClick={() => {
              const routes = ["/inquery", "/unitlink", "/projects"];
              window.location.href = routes[active - 1] || "/projects";
            }}
          />
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (dispatch:any) => ({
  dispatch,
  userData:dispatch.general.userData,
});

export default connect(mapStateToProps)(InsuranceRate);